<template>
    <div>
        <modal
            class="new-modal-default"
            :name="modal_name"
            transition="nice-modal-fade"
            :delay="100"
            :height="100"
            :min-width="400"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="false"
            style="pointer-events:inherit !important" 
            v-bind:click-to-close="false"
        >
            <div class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center" style="background-color: #fff !important;">
                <!-- <img src="/static/images/parrot.svg" style="height: 10rem !important" /> -->
                <div style="font-size: 16px">
                    {{ follower }} started following {{ following }}
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    props: ["modal_name","follower","following"],
}
</script>


// WEBPACK FOOTER //
// src/components/alertModals/Following.vue